const s = {
  id: "MassachusettsMassCash",
  logo: !0,
  name: "Mass Cash",
  style: {
    colorPrimary: "#1c4177"
  }
};
export {
  s as default
};
